import {ModuleWithProviders, NgModule} from '@angular/core';
import {ScenarioImageServiceImpl} from './scenario-image/scenario-image.service.impl';
import {DoorServiceImpl} from './door/door.service.impl';
import {DoorLoader} from './door/door.loader';
import {GraphqlDoorLoader} from './door/graphql.door.loader';
import {FavoriteDoorService} from './favorite-door/favorite-door.service';
import {FilterService} from './filter/filter.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {CustomerTranslateLoader} from './customer/customer-translate-loader';
import {TrackingService} from './tracking.service';
import {
  GetCustomerConfigGQL,
  GetExampleImagesGQL,
  GetVisualDoorGQL,
  GetVisualDoorsStateServiceGQL
} from '../../generated/graphql';
import {ScenarioImageService} from './scenario-image/scenario-image.service';
import {DoorService} from './door/door.service';
import {CustomerService} from './customer/customer.service';
import {UserService} from './user/user.service';
import {CustomerServiceImpl} from './customer/customer.service.impl';
import {ScenarioImageLoader} from './scenario-image/scenario.image.loader';
import {GraphqlScenarioImageLoader} from './scenario-image/scenario-image.loader.impl';
import {UserServiceImpl} from './user/user.service.impl';
import {QrCodeService} from './qr-code/qr-code.service';
import {QrCodeServiceImpl} from './qr-code/qr-code.service.impl';
import {BackendFavoriteDoorService} from "./favorite-door/backend.favorite-door.service";
import {UserStorageService} from "./user/user.storage.service";
import {GenericFilterService} from "./filter/generic-filter.service";
import {DoorsuppliesonlineFilterService} from "./filter/doorsuppliesonline-filter.service";
import {VisualizeEngineModule} from "@door-vision/visualisation-engine";

const getFilterClass = (): { new(...args: any[]): FilterService<any> } => {
  switch (CustomerServiceImpl.GetCustomerKey().toLowerCase()) {
    case 'doorsuppliesonline':
      return DoorsuppliesonlineFilterService
    default:
      return GenericFilterService
  }
};

const providers = [
  {
    provide: ScenarioImageService,
    useClass: ScenarioImageServiceImpl
  },

  {
    provide: DoorService,
    useClass: DoorServiceImpl
  },
  {
    provide: UserService,
    useClass: UserServiceImpl
  },
  {
    provide: QrCodeService,
    useClass: QrCodeServiceImpl
  },
  {
    provide: CustomerService,
    useClass: CustomerServiceImpl
  },
  {
    provide: ScenarioImageLoader,
    useClass: GraphqlScenarioImageLoader
  },
  {
    provide: DoorLoader,
    useClass: GraphqlDoorLoader
  },
  {
    provide: FavoriteDoorService,
    useClass: BackendFavoriteDoorService
  },
  {
    provide: FilterService,
    useClass: getFilterClass()
  },
  TrackingService,

  UserStorageService,

  // generated graphql stuff
  GetCustomerConfigGQL,
  GetExampleImagesGQL,
  GetVisualDoorGQL,
  GetVisualDoorsStateServiceGQL
];

@NgModule({
  imports: [
    VisualizeEngineModule,
    TranslateModule.forRoot({
      defaultLanguage: navigator.language,
      loader: {
        provide: TranslateLoader,
        useExisting: CustomerTranslateLoader
      }
    })
  ],
  providers,
  exports: [TranslateModule]
})
export class ServiceModule {
  public static forRoot(): ModuleWithProviders<ServiceModule> {
    return {
      ngModule: ServiceModule,
      providers
    };
  }
}
